export default __webpack_public_path__ + "static/media/heartIcon_inactiveFavourite.179b2734.svg";